<template>
  <div class="g-bd">
    <div class="con-tag">
      <div class="con-tag">
        <h2>
          课
          <span>/</span>程 <span>/</span>列 <span>/</span>表
        </h2>
      </div>
    </div>
    <div class="con-body">
      <rankList></rankList>
    </div>
  </div>
</template>

<script>
import rankList from "./rankList.vue";
export default {
  components: {
    rankList
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="scss">
.g-bd {
  background: #f7f8f9;
  background-image: url(/images/all_bg.png);
  background-position: top;
  background-repeat: no-repeat;
  background-size: 100% 150px;
}
.con-tag {
  width: 1200px;
  margin: 0px auto;
  h2 {
    font-size: 34px;
    text-align: center;
    color: #fff;
    span {
      line-height: 150px;
      font-size: 16px;
      padding: 0 10px;
      vertical-align: middle;
    }
  }
}
</style>
